import { useState, useMemo } from "react";

import {
    Box,
    Tabs,
    Tab,
    Stack,
    Typography,
} from "@mui/material";

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

export default function FilterListTab({ tabChange, listedOrders = [] }) {
    const [value, setValue] = useState(0);

    const counts = useMemo(() => ({
        all: listedOrders.length,

        marked: listedOrders.filter(
            order =>
                order.Remarks === "Marked" &&
                order.OrderStat !== "Cancelled"
        ).length,

        inTransit: listedOrders.filter(
            order =>
                order.Remarks === "In_Transit" &&
                order.OrderStat !== "Cancelled"
        ).length,

        cancelled: listedOrders.filter(
            order => order.OrderStat === "Cancelled"
        ).length,
    }), [listedOrders]);

    const handleChange = (_, newValue) => {
        setValue(newValue);

        const tabMap = {
            0: "",
            1: "Marked",
            2: "In Transit",
            3: "Cancelled",
        };

        tabChange(tabMap[newValue]);
    };

    const tabs = [
        {
            label: "All",
            count: counts.all,
        },
        {
            label: "Marked",
            count: counts.marked,
        },
        {
            label: "In Transit",
            count: counts.inTransit,
        },
        {
            label: "Cancelled",
            count: counts.cancelled,
        },
    ];

    return (
        <Box
            sx={{
                width: "100%",
                borderBottom: "1px solid #E5E7EB",
            }}
        >
            <Tabs
                value={value}
                onChange={handleChange}
                TabIndicatorProps={{
                    sx: {
                        height: 3,
                        borderRadius: "4px 4px 0 0",
                        backgroundColor: "#2563EB",
                    },
                }}
                sx={{
                    minHeight: 56,
                }}
            >
                {tabs.map((tab, index) => (
                    <Tab
                        key={index}
                        disableRipple
                        {...a11yProps(index)}
                        label={
                            <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                            >
                                <Typography
                                    sx={{
                                        fontSize: 14,
                                        fontWeight:
                                            value === index
                                                ? 700
                                                : 600,
                                    }}
                                >
                                    {tab.label}
                                </Typography>

                                <Box
                                    sx={{
                                        minWidth: 22,
                                        height: 22,
                                        px: 0.75,

                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",

                                        borderRadius: "999px",

                                        fontSize: 12,
                                        fontWeight: 700,

                                        backgroundColor:
                                            value === index
                                                ? "#EFF6FF"
                                                : "#F3F4F6",

                                        color:
                                            value === index
                                                ? "#2563EB"
                                                : "#64748B",
                                    }}
                                >
                                    {tab.count}
                                </Box>
                            </Stack>
                        }
                        sx={{
                            minHeight: 56,

                            textTransform: "none",

                            color:
                                value === index
                                    ? "#111827"
                                    : "#6B7280",

                            transition:
                                "all 0.2s ease",

                            "&.Mui-selected": {
                                color: "#111827",
                            },

                            "&:hover": {
                                backgroundColor:
                                    "#FAFAFA",
                                color: "#111827",
                            },
                        }}
                    />
                ))}
            </Tabs>
        </Box>
    );
}